import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import GoogleAnalytics from '../components/GoogleAnalytics';

const Enquiry = () => {
  const [formStatus, setFormStatus] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "73f7f7a3-36f0-49aa-8aae-f59de3e98cf5");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setFormStatus("success");
      setSubmitted(true);  // Mark the form as successfully submitted
      setTimeout(() => {
        event.target.reset();  // Reset form after a slight delay
        setSubmitted(false);  // Reset the submitted status for potential future submissions
      }, 3000);  // Give user a few seconds to read the success message
    } else {
      setFormStatus("error");
      console.log("Error", data);
    }
  };

  return (
    <div>
      <GoogleAnalytics/>
      <Helmet>
        <title>Enquiry</title>
      </Helmet>

      <section
        className="page-title "
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Enquiry</h1>
          </div>
        </div>
      </section>

      <section className="news-details-section fix section-padding pt-0 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="de-item-list mb30 pt-5">
                  <h3 className=' text-center darkcolor'>Do You Have Any Query ?</h3>
                  {!submitted ? (
                    <form 
                      onSubmit={onSubmit}
                      name="contactForm" 
                      id="contact_form" 
                      className="form-border pb-0" 
                      method="post"
                    >
                      <input type="hidden" />
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="name" className="small fs-5">Your Full Name <i className="fa fa-user darkcolor"></i></label>
                            <input 
                              name="name" 
                              id="name" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Your Full Name" 
                              required 
                              pattern="[A-Za-z\s]+" 
                              title="Name must contain only letters" 
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="email" className="small fs-5">Your Email <i className="fa fa-envelope darkcolor"></i></label>
                            <input 
                              type="email" 
                              name="email" 
                              id="email" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Your Email" 
                              required 
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" 
                              title="Please enter a valid email address" 
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="phone" className="small fs-5">Your Phone <i className="fa fa-phone darkcolor"></i></label>
                            <input 
                              type="tel" 
                              name="phone" 
                              id="phone" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Your Phone" 
                              required 
                              pattern="[0-9]{10}" 
                              title="Phone number must be of 10 digits" 
                            />
                          </div>
                        </div>
                 
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="days" className="small fs-5">Number of Days <i className="fa fa-calendar-check darkcolor"></i></label>
                            <input 
                              name="days" 
                              id="days" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Number of Days" 
                              required 
                              min="1" 
                              max="100" 
                              step="1" 
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="pick_up_point" className="small fs-5">Pick Up Point <i className="fa fa-map-marker-alt darkcolor"></i></label>
                            <input 
                              name="pick_up_point" 
                              id="pick_up_point" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Pick Up Point" 
                              required 
                              pattern="[A-Za-z\s]+" 
                              title="Pick Up Point must contain only letters" 
                            />
                          </div>
                        </div>
                     
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="date" className="small fs-5">Date of Journey <i className="fa fa-calendar-alt ml-2 darkcolor"></i></label>
                            <input 
                              type="date" 
                              name="date" 
                              id="date" 
                              className="form-control form-control-lg rounded-0" 
                              placeholder="Date of Journey" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
  <div className="form-group position-relative">
    <label htmlFor="cabs" className="small fs-5">Select Cabs <i className="fa fa-taxi darkcolor"></i></label>
    <select 
      name="cabs" 
      id="cabs" 
      className="border py-2 form-control form-control-lg rounded-0 custom-select-arrow" 
      required
    >
      <option value="" disabled>Select Cabs</option>
      <option value="Swift Dzire (4 + 1 Seater)">Swift Dzire (4 + 1 Seater)</option>
      <option value="Honda City (4 + 1 Seater)">Honda City (4 + 1 Seater)</option>
      <option value="Nexa Ciaz (4 + 1 Seater)">Nexa Ciaz (4 + 1 Seater)</option>
      <option value="Ertiga (7 + 1 Seater)">Ertiga (7 + 1 Seater)</option>
      <option value="Innova (7 + 1 Seater)">Innova (7 + 1 Seater)</option>
      <option value="Innova Crysta (7 + 1 Seater)">Innova Crysta (7 + 1 Seater)</option>
      <option value="Fortuner (8 + 1 Seater)">Fortuner (8 + 1 Seater)</option>
      <option value="Audi (4 + 1 Seater)">Audi (4 + 1 Seater)</option>
      <option value="BMW (8 + 1 Seater)">BMW (8 + 1 Seater)</option>
      <option value="Jaguar (8 + 1 Seater)">Jaguar (8 + 1 Seater)</option>
      <option value="Tata Winger (13/17 Seater)">Tata Winger (13/17 Seater)</option>
      <option value="13 Seater Tempo Traveller (13 Seater)">13 Seater Tempo Traveller (13 Seater)</option>
      <option value="17 Seater Tempo Traveller (17 Seater)">17 Seater Tempo Traveller (17 Seater)</option>
      <option value="20 Seater Tempo Traveller (20 Seater)">20 Seater Tempo Traveller (20 Seater)</option>
      <option value="Luxury Bus (32 Seater)">Luxury Bus (32 Seater)</option>
    </select>
  </div>
</div>


                        <div className="form-group position-relative col-12">
                          <textarea 
                            name="message" 
                            id="message" 
                            className="form-control form-control-lg rounded-0" 
                            placeholder="Your Message" 
                            required 
                          />
                        </div>
                        <div className="g-recaptcha" data-sitekey="copy-your-site-key-here"></div>
                        <div id='submit' className="mt20 text-center pb-3 px-4">
                          <input 
                            type='submit' 
                            id='send_message' 
                            value='Submit ' 
                            className="btn-main mt-2 py-3 px-3 text-center fw-bold fs-3  bg-tn" 
                          />
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className="success-message">
                      <h3>Your details have been submitted successfully!</h3>
                      <p>Thank you for your enquiry. We will get back to you shortly.</p>
                    </div>
                  )}

                  {/* Error Message */}
                  {formStatus === "error" && (
                    <div id="error_message" className='error'>
                      Sorry, something went wrong. Try again later.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Enquiry;
